// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".restricted-enrollment-message-container[data-v-30b722bf]{height:95vh}", ""]);
// Exports
module.exports = exports;
